// @ts-nocheck

import React from 'react';
import { Select } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { ItemInputSelect } from 'types/ItemInputSelect';
import * as S from './styles';

interface InputSelectProps {
  listOptions: ItemInputSelect[];
  getValue: any;
  initialValue: string | number | null;
  placeholder?: string;
}

export default function InputSelect({
  listOptions,
  getValue,
  initialValue,
  placeholder = 'customTags.selectAOption',
}: InputSelectProps) {
  const { t } = useTranslation();
  return (
    <Select
      placeholder={t(placeholder)}
      defaultValue={initialValue === null ? listOptions[0].id : initialValue}
      onChange={value => {
        getValue(value.target.value);
      }}
    >
      {listOptions.length > 0 &&
        listOptions.map(item => (
          <option key={item.id} value={item.id}>
            {t(item.textOption)}
          </option>
        ))}
    </Select>
  );
}
